<template>
  <div class="date-picker-container">
    <span class="date-display">{{ formattedDate }}</span>
    <v-icon class="calendar-icon" @click="showDatePicker">mdi-calendar</v-icon>

    <v-dialog v-model="dialog" width="auto">
      <v-card>
        <v-card-title>Seleccionar fecha</v-card-title>
        <v-card-text>
          <v-date-picker
            v-model="internalDateObject"
            @update:model-value="onDateSelected"
          ></v-date-picker>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { formatDate } from '@/utils/helpers'

const props = defineProps({
  modelValue: {
    type: String,
    default: null
  }
})

const emit = defineEmits(['update:modelValue'])

const dialog = ref(false)
const internalDateObject = ref(null)

// Inicializar el objeto Date interno a partir del modelValue (string)
if (props.modelValue) {
  internalDateObject.value = new Date(props.modelValue)
}

// Formatea la fecha para mostrarla
const formattedDate = computed(() => {
  if (!props.modelValue) return 'Sin fecha'
  return formatDate(props.modelValue)
})

// Actualiza el objeto Date interno cuando cambia el modelValue (string)
watch(
  () => props.modelValue,
  (newValue) => {
    if (newValue) {
      internalDateObject.value = new Date(newValue)
    } else {
      internalDateObject.value = null
    }
  }
)

// Muestra el selector de fecha
const showDatePicker = () => {
  dialog.value = true
}

// Convierte el objeto Date seleccionado a string en formato ANSI y lo emite
const onDateSelected = (date) => {
  if (date) {
    const ansiDate = formatDateToAnsi(date)
    emit('update:modelValue', ansiDate)
  }
  dialog.value = false
}

// Función para formatear una fecha a formato ANSI (YYYY-MM-DD)
function formatDateToAnsi(date) {
  if (!date) return null
  const d = new Date(date)
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}
</script>

<style scoped>
.date-picker-container {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.calendar-icon {
  cursor: pointer;
  color: var(--v-primary-base);
}

.date-display {
  font-weight: 500;
}
</style>
